import React, { Component } from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { Image, Wrapper, ContactForm } from '.';
import './PostcardForm.scss';

class PostcardFormTemplate extends Component {
  render() {
    const {
      title,
      formName,
      data,
    } = this.props;
    const { stampImage } = data;
    const stampImageObj = {
      localFile: stampImage,
    };
    return (
      <section className="postcard-form">
        <Wrapper>
          <div className="postcard-container">
            <div className="inner-container">
              <h2 className="headline">{title}</h2>
              <div className="stamp-container">
                <Image image={stampImageObj} className="contain" />
              </div>
              <ContactForm formName={formName} />
            </div>
          </div>
        </Wrapper>
      </section>
    );
  }
}

const PostcardForm = props => (
  <StaticQuery
    query={graphql`
      query {
        stampImage: file(relativePath: { eq: "assets/images/stamp.png" }) {
          childImageSharp {
            fluid(maxWidth: 150, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => <PostcardFormTemplate data={data} {...props} />}
  />
);

export default PostcardForm;
